import ProfileLinks from './ProfileLinks'

export default ProfileLinks
